"use client"

import { AddToCartButton } from "src/components/styled/AddToCartButton"
import { useProductContext } from "../context"

export const ProductAddToCartButton = () => {
  const product = useProductContext()

  return (
    <AddToCartButton
      resolvedId={product.resolvedId}
      price={product.resolvedPrice}
      available={product.resolvedAvailable}
    />
  )
}
